import React, { Component, PropTypes } from "react";
import LeftComponent from "components/Authorization/LeftComponent";
import NewPasswordForm from "components/Authorization/NewPassword/NewPasswordForm";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import validator from "services/validator.js";

const { newPasswordSaga, addValidateError, cleanErrors } = actions;

const { NEW_PASSWORD_SAGA } = constants;

class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        password_confirmation: "",
        token:
          props.location && props.location.query && props.location.query.token,
      },
      passwordType: "password",
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.newPassword(this.state.user);
  };

  onFieldChange = (e) => {
    const newState = {
      ...this.state.user,
      [e.target.name]: e.target.value,
    };

    this.setState({ user: newState }); //, () => { on field change validation
    // this.props.addErrors(validator.validate(this.state.user, 'newPassword'));
    // });
  };

  onPasswordTypeChange = (status) => {
    this.setState({
      passwordType: status ? "text" : "password",
    });
  };

  render() {
    return (
      <main className="site--width">
        <div className="container_content_signin">
          <LeftComponent />
          <NewPasswordForm
            user={this.state.user}
            errors={this.props.errors || {}}
            passwordType={this.state.passwordType}
            onSubmit={this.onSubmit}
            onFieldChange={this.onFieldChange}
            onPasswordTypeChange={this.onPasswordTypeChange}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[`${NEW_PASSWORD_SAGA}_FRONTEND`],
});

const mapDispatchToProps = (dispatch) => ({
  newPassword: (user) => dispatch(newPasswordSaga(user)),
  addErrors: (errors) => dispatch(addValidateError(NEW_PASSWORD_SAGA, errors)),
  cleanErrors: () => dispatch(cleanErrors(NEW_PASSWORD_SAGA)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword);



// WEBPACK FOOTER //
// ./src/containers/Authorization/NewPassword/NewPassword.js